import { GoToAccountSettingsCTA } from "./ctas";
export var EoriDetailsIA = function EoriDetailsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize), NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "JyA1NQ",
    defaultMessage: [{
      "type": 0,
      "value": "Wat is een EORI-nummer?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VfEzWr",
    defaultMessage: [{
      "type": 0,
      "value": "Het ‘Economic Operators Registration and Identification’-nummer (EORI) is een uniek nummer dat door bedrijven wordt gebruikt om zich bij de douane te identificeren op douaneaangiften en andere invoerdocumentatie. Je kunt je EORI-nummer toevoegen of bijwerken op je Faire-profiel onder het gedeelte ‘Import- en belastinggegevens’ op de pagina ‘Accountinstellingen’."
    }]
  });
};
var NODE_ON_ORDERS_WITHOUT_EORI = function NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize) {
  return strictLocalize({
    id: "g5oER+",
    defaultMessage: [{
      "type": 0,
      "value": "Let op: bestellingen zonder EORI-nummer lopen het risico bij de douane te worden vastgehouden en kunnen worden teruggestuurd. Als je geen EORI-nummer hebt, kun je er een aanvragen op de website van je lokale overheid. De aanvraag is gratis en duurt slechts een paar minuten. Je ontvangt je EORI-nummer binnen drie tot vijf werkdagen."
    }]
  });
};